<template>
    <div>
        <div class="layout">
            <div class="layout__header">
                <div class="layout__title">
                    <h3>Guía de Remisión {{ numero_comprobante }}</h3>
                    <label>
                        <div v-show="estado === 'PPR' && anulado === 'N'" class="noti-warning"><strong>PENDIENTE DE AUTORIZACIÓN</strong></div>
                        <div v-show="anulado === 'S'" class="noti-danger"><strong>ANULADO</strong></div>
                        <div v-show="(estado === undefined || estado === null) && anulado === 'N' && !enColaAutorizacion" class="noti-info"><strong>EMITIDO</strong></div>
                        <div v-show="estado === 'AUT' && anulado === 'N'" class="noti-success"><strong>AUTORIZADO</strong></div>
                        <div v-show="estado === 'N' && anulado === 'N'" class="noti-secondary"><strong>NUEVO</strong></div>
                        <div v-show="estado === 'NAT' && anulado === 'N'" class="noti-danger"><strong>NO AUTORIZADO</strong></div>
                        <div v-show="enColaAutorizacion" class="noti-primary"><strong>PENDIENTE DE ENVÍO AL SRI</strong></div>
                    </label>
                </div>
                <div class="layout__controls">
                    <button :disabled="!permiteAnularGuiaRemision && !permiteEditarGuiaRemision" @click="$modal.show('listaGuiasRemision')" class="btn-info"><i class="fa fa-search"></i> <span>Consultar</span></button>
                </div>
            </div>
            <div class="layout__main">
                <div class="layout__main-form">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="card">
                                <div class="card__title">
                                    <h5>Información del comprobante</h5>
                                </div>
                                <div class="card__content">
                                    <div class="row">
                                        <div class="col-xs-12 col-md-4">
                                            <div :class="{
                                                    'select2--disabled' : !editable || id_comprobante !== ''
                                                }" class="form-field select2">
                                                <div class="select2-field">
                                                    <v-select :options="puntosEmision" label="descripcion" id="puntoEmision" placeholder="Seleccione..." v-model="selectedPuntoEmision"></v-select>
                                                    <label for="puntoEmision">Punto de emisión</label>
                                                    <span v-if="errores.id_punto_emision" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.id_punto_emision[0] }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <div class="datepicker-field">
                                                    <date-picker :disabled="!editable" v-model="form.fecha_emision" type="date" format="dd-MM-yyyy" id="fecha_emision" lang="es"></date-picker>
                                                    <label for="fecha_emision">Fecha de emisión</label>
                                                    <span v-if="errores.fecha_emision" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.fecha_emision[0] }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <div class="form-group">
                                                    <input-field :disabled="!editable" v-model="numero_identificacion" id="numeroIdentificacion" placeholder="Id transportista">
                                                        <span>Identificación del transportista</span>
                                                        <span v-if="errores.id_transportista" class="helper-text text-danger" slot="helper">
                                                            <strong>{{ errores.id_transportista[0] }}</strong>
                                                        </span>
                                                    </input-field>
                                                    <button :disabled="!editable" @click="consultarCliente" v-show="!tieneTransportista" class="btn-success" type="button"><i class="fa fa-check"></i></button>
                                                    <button :disabled="!editable" @click="quitarPersona" v-show="tieneTransportista" class="btn-danger" type="button"><i class="fa fa-ban"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <div class="form-group">
                                                    <input-field v-model="nombre_transportista" id="transportista" placeholder="Escoja un transportista..." readonly>
                                                        <span>Transportista</span>
                                                    </input-field>
                                                    <button :disabled="!editable" @click="$modal.show('listaTransportistas')" class="btn-info" type="button"><i class="fa fa-search"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field type="tel" v-mask="'AAA####'" :disabled="!editable" v-model="form.placa_transportista" id="placa" placeholder="Placa">
                                                    Placa de transportista
                                                    <span v-if="errores.placa_transportista" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.placa_transportista[0] }}</strong>
                                                    </span>
                                                </input-field>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field :disabled="!editable" v-model="form.direccion_partida" placeholder="Escriba una dirección..." id="direccionPartida">
                                                    Dirección de partida
                                                    <span v-if="errores.direccion_partida" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.direccion_partida[0] }}</strong>
                                                    </span>
                                                </input-field>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <div class="datepicker-field">
                                                    <date-picker :disabled="!editable" v-model="form.fecha_inicio_transporte" type="date" format="dd-MM-yyyy" id="fecha_inicio" lang="es"></date-picker>
                                                    <label for="fecha_inicio">Fecha de inicio</label>
                                                    <span v-if="errores.fecha_inicio_transporte" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.fecha_inicio_transporte[0] }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <div class="datepicker-field">
                                                    <date-picker :disabled="!editable" v-model="form.fecha_fin_transporte" type="date" format="dd-MM-yyyy" id="fecha_fin" lang="es"></date-picker>
                                                    <label for="fecha_fin">Fecha de fin</label>
                                                    <span v-if="errores.fecha_fin_transporte" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.fecha_fin_transporte[0] }}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field :disabled="!editable" id="email" type="text" v-model="form.email">
                                                    E-mail
                                                    <span v-if="errores.email" class="helper-text text-danger" slot="helper">
                                                        <strong>{{ errores.email[0] }}</strong>
                                                    </span>
                                                </input-field>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field v-model="clave_acceso" id="clave_acceso" readonly>
                                                    Clave de acceso
                                                </input-field>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field readonly v-model="form.numero_autorizacion" id="numero_autorizacion">
                                                    Número de autorización
                                                </input-field>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4">
                                            <div class="form-field">
                                                <input-field readonly id="fecha_autorizacion" v-model="form.fecha_autorizacion">
                                                    Fecha de autorización
                                                </input-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xs-12 col-md-4">
                            <div class="card">
                                <div class="card__title">
                                    <h5>Información adicional</h5>
                                </div>
                                <div class="card__content">
                                    <tabla-informacion-adicional :disabled="!editable" :errores="errores" v-model="form.informacionAdicional"></tabla-informacion-adicional>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <div class="card">
                                <div class="card__title">
                                    <h5>Detalle de la guía de remisión</h5>
                                </div>
                                <div class="card__content">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <tabla-detalle-guia-remision @personaActualizada="personaActualizada" @personaEliminada="personaEliminada" @personaSeleccionada="personaSeleccionada" :disabled="!editable" v-model="form.detalles"></tabla-detalle-guia-remision>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout__main-buttons">
                    <div class="card">
                        <div class="card__content">
                            <button :disabled="(estado === 'N' && !permiteCrearGuiaRemision) || (estado !== 'N' && !permiteEditarGuiaRemision)" v-show="estado !== 'PPR' && anulado !== 'S'" @click="guardarComprobante" type="button" class="btn-success"><i class="fa fa-save"></i> <span>Guardar</span></button>
                            <button :disabled="!permiteCrearGuiaRemision" @click="nuevoComprobante" type="button" class="btn-light btn--text"><i class="fa fa-plus"></i> <span>Nuevo</span></button>
                            <button :disabled="!permiteAnularGuiaRemision" @click="anularComprobante" v-show="estado !== 'N' && anulado === 'N'" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Anular</span></button>
                            <button @click="imprimirComprobante" v-show="estado !== 'N'" type="button" class="btn-bus200 btn--text"><i class="fa fa-print"></i> <span>Imprimir</span></button>
                            <button v-show="!enColaAutorizacion && esElectronico && estado !== 'AUT' && estado !== 'N' && anulado === 'N' && permiteAutorizarGuiaRemision" @click="autorizar" class="btn-primary btn--text"><i class="fa fa-paper-plane"></i><span>Autorizar</span></button>
                            <button v-show="estado === 'AUT'" class="btn-info btn--text" type="button" @click="enviarCorreo"><i class="fa fa-envelope-o"></i> <span>Enviar correo</span></button>
                            <button v-show="estado !== 'N' && esElectronico" @click="abrirLogs" type="button" class="btn-secondary btn--text"><i class="fa fa-file-o"></i> <span>Logs</span></button>
                            <button class="btn-secondary btn--text" type="button" @click="verAnterior">
                                <i class="fa fa-toggle-left"></i><span>Anterior</span>
                            </button>
                            <button class="btn-secondary btn--text" type="button" @click="verSiguiente">
                                <i class="fa fa-toggle-right"></i><span>Siguiente</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="listaTransportistas" width="70%" height="auto" scrollable>
            <lista-personas :filterStatus="false" @selected="selectedPersona"  tipoFiltro="T"></lista-personas>
        </modal>
        <modal scrollable width="70%" height="auto" name="persona">
            <persona tipoFiltro="T" :numeroIdentificacion="numero_identificacion" @saved="savedPersona" :searchButton="false"></persona>
        </modal>
        <modal name="listaGuiasRemision" height="auto" width="70%" scrollable>
            <lista-comprobantes @selected="selectedComprobante" :tipoComprobante="codigoGuiaRemision"></lista-comprobantes>
        </modal>
        <modal width="50%" name="imprimir" height="auto" scrollable>
            <imprimir :id_comprobante="id_comprobante"></imprimir>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        permiteAutorizarGuiaRemision : {
            type : Boolean,
            required : false,
            default : false
        },
        codigoGuiaRemision : {
            type : String,
            default : '06',
            required : false
        },
        permiteCrearGuiaRemision : {
            type : Boolean,
            required : true,
            default : false
        },
        permiteEditarGuiaRemision : {
            type : Boolean,
            required : true,
            default : false
        },
        permiteAnularGuiaRemision : {
            type : Boolean,
            required : true,
            default : false
        },
        factura : {
            type : Object, 
            required : false,
            default : function () {
                return null;
            }
        },
        comprobante : {
            type : Object,
            required : false,
            default : function () {
                return null;
            }
        }
    },
    data : function () {
        return {
            numero_comprobante : '',
            clave_acceso : '',
            id_comprobante : '',
            nombre_transportista : '',
            numero_identificacion : '',
            form : {
                fecha_emision : moment(new Date()).format('YYYY-MM-DD'),
                id_transportista : '',
                placa_transportista : '',
                direccion_partida : '',
                fecha_inicio_transporte : moment(new Date()).format('YYYY-MM-DD'),
                fecha_fin_transporte : moment(new Date()).format('YYYY-MM-DD'),
                informacionAdicional : [],
                detalles : [],
                id_punto_emision : '',
                email : '',
                _method : undefined,
                fecha_autorizacion : '',
                numero_autorizacion : '',
            },
            estado : 'N',
            anulado : 'N',
            selectedPuntoEmision : null,
            errores : {},
            url : url,
            puntosEmision : [],
            pendiente_envio : 'N'
        };  
    },
    methods : {
        verAnterior : function () {
            this.irADocumento('A');
        },
        verSiguiente : function () {
            this.irADocumento('S');
        },
        irADocumento : function (tipoProximidad) {
            let that = this;
            axios.get(url + '/comprobantes/' + this.codigoGuiaRemision + '/' 
            + tipoProximidad  + (this.id_comprobante != null && this.id_comprobante !== ''?'/' + this.id_comprobante:'/T')).then(function (response) {
                let id = response.data.id;
                if (id === null)
                swal('No hay documento disponible.', 'Aviso', 'warning');
                else 
                {
                location.href = url + '/comprobantes?tipo_comprobante=' + that.codigoGuiaRemision + '&id_comprobante=' + id;
                }
            });
        },
        autorizar : function () {
            let that = this;
            swal({
                title: '¿Desea autorizar este comprobante?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Autorizar comprobante',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    axios.post(that.url + '/autorizacion-documentos', {
                        comprobantes : [that.id_comprobante]
                    }).then(function (response) {
                        swal('El comprobante ha sido enviado a autorizar.', 'Aviso', 'success');
                        that.pendiente_envio = 'S';
                        
                    }).catch(function (error) {
                        swal('Hubo un error al intentar autorizar el documento, intente nuevamente.', 'Aviso', 'warning');
                    });
                }
            })
        },
        obtenerInformacionAdicional : function (nombre) {
            for (let i = 0; i < this.form.informacionAdicional.length; i++) 
                if (this.form.informacionAdicional[i].nombre_campo === nombre)
                    return this.form.informacionAdicional[i];
            return null;
        },
        personaActualizada : function (email, telefono) {
            this.eliminarDatos(email, telefono)
        },
        eliminarDatos : function (email, telefono) {
            let infoEmail = this.obtenerInformacionAdicional('Email');
            if (infoEmail !== null) {
                if (email !== undefined && email !== null && email !== '') {
                    let partsEmail = email.split(',');
                    for (let i = 0; i < partsEmail.length; i++)
                        if (infoEmail.valor_campo.includes(partsEmail[i]))
                        {
                            let replaced = infoEmail.valor_campo.replace(partsEmail[i] + ',', '');
                            if (replaced.includes(partsEmail[i]))
                            {
                                replaced = infoEmail.valor_campo.replace(',' + partsEmail[i], '');
                                if (replaced.includes(partsEmail[i]))
                                    replaced = infoEmail.valor_campo.replace(partsEmail[i], '');
                            }
                            infoEmail.valor_campo = replaced;
                            replaced = this.form.email.replace(partsEmail[i] + ',', '');
                            if (replaced.includes(partsEmail[i]))
                            {
                                replaced = this.form.email.replace(',' + partsEmail[i], '');
                                if (replaced.includes(partsEmail[i]))
                                    replaced = this.form.email.replace(partsEmail[i], '');
                            }
                            this.form.email = replaced;
                        }
                    if (infoEmail.valor_campo === '')
                        this.form.informacionAdicional.splice(this.form.informacionAdicional.indexOf(infoEmail), 1);
                }
            }
            let infoTelefono = this.obtenerInformacionAdicional('Teléfono');
            if (infoTelefono !== null) {
                if (telefono !== undefined && telefono !== null && telefono !== '') {
                    let partsTelefono = telefono.split(',');
                    for (let i = 0; i < partsTelefono.length; i++)
                        if (infoTelefono.valor_campo.includes(partsTelefono[i]))
                        {
                            let replaced = infoTelefono.valor_campo.replace(partsTelefono[i] + ',', '');
                            if (replaced.includes(partsTelefono[i]))
                            {
                                replaced = infoTelefono.valor_campo.replace(',' + partsTelefono[i], '');
                                if (replaced.includes(partsTelefono[i]))
                                    replaced = infoTelefono.valor_campo.replace(partsTelefono[i], '');
                            }
                            infoTelefono.valor_campo = replaced;
                        }
                    if (infoTelefono.valor_campo === '')
                        this.form.informacionAdicional.splice(this.form.informacionAdicional.indexOf(infoTelefono), 1);
                }
            }
        },
        personaEliminada : function (detalle, index) {
            this.eliminarDatos(detalle.email, detalle.telefono)
        },
        personaSeleccionada : function (detalle, index) {
            if (detalle.email !== undefined && detalle.email !== null && detalle.email !== '') {
                let infoEmail = this.obtenerInformacionAdicional('Email');
                if (infoEmail === null)
                {
                    infoEmail = {
                        nombre_campo : 'Email',
                        valor_campo : detalle.email
                    };
                    this.form.informacionAdicional.push(infoEmail)
                }
                else {
                    let nuevosEmail = detalle.email;
                    let partsNuevoEmail = detalle.email.split(',');
                    for (let i = 0; i < partsNuevoEmail.length; i++) {
                        if (!infoEmail.valor_campo.includes(partsNuevoEmail[i]))
                            infoEmail.valor_campo += ((infoEmail.valor_campo !== '')? ',':'') + detalle.email;
                    }
                }
                if (this.form.email === undefined || this.form.email === null)
                    this.form.email = '';
                let partsEmail = infoEmail.valor_campo.split(',');
                for (let i = 0; i < partsEmail.length; i++)
                    if (!this.form.email.includes(partsEmail[i]))
                        this.form.email += (this.form.email !== ''?',':'') + partsEmail[i];
            }
            if (detalle.telefono !== undefined && detalle.telefono !== null && detalle.telefono !== '') {
                let infoTelefono = this.obtenerInformacionAdicional('Teléfono');
                if (infoTelefono === null) {
                    infoTelefono = {
                        nombre_campo : 'Teléfono',
                        valor_campo : detalle.telefono
                    };
                    this.form.informacionAdicional.push(infoTelefono);
                }
                else {
                    let nuevosTelefonos = detalle.telefono;
                    let partsTelefono = detalle.telefono.split(',');
                    for (let i = 0; i < partsTelefono.length; i++)
                        if (!infoTelefono.valor_campo.includes(partsTelefono[i]))
                            infoTelefono.valor_campo += ((infoTelefono.valor_campo !== '')?',':'') + detalle.telefono;
                }
            }
        },
        limpiar : function () {
            this.form = {
                fecha_emision : moment(new Date()).format('YYYY-MM-DD'),
                id_transportista : '',
                placa_transportista : '',
                direccion_partida : '',
                fecha_inicio_transporte : moment(new Date()).format('YYYY-MM-DD'),
                fecha_fin_transporte : moment(new Date()).format('YYYY-MM-DD'),
                informacionAdicional : [],
                detalles : [],
                id_punto_emision : '',
                email : '',
                _method : undefined,
                numero_autorizacion : '',
                fecha_autorizacion : ''
            };
            this.clave_acceso = '';
            this.numero_comprobante = '';
            this.selectedPuntoEmision = null;
            this.nombre_transportista = '';
            this.pendiente_envio = 'N';
            this.numero_identificacion = '';
            if (this.puntosEmision.length > 0)
                this.selectedPuntoEmision = this.puntosEmision[0];
        },
        nuevoComprobante : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo comprobante?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Nuevo comprobante',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    that.limpiar();
                    that.limpiarErrores();
                    that.estado = 'N';
                    that.anulado = 'N';
                }
            })
        },
        selectedComprobante : function (comprobante) {
            this.selectedPuntoEmision = null;
            this.form.fecha_emision = comprobante.fecha_emision;
            this.pendiente_envio = comprobante.pendiente_envio;
            this.estado = comprobante.id_estado_comprobante;
            this.clave_acceso = comprobante.clave_acceso;
            this.numero_comprobante = comprobante.numero_documento;
            this.form.email = comprobante.correo_cliente;
            this.form.placa_transportista = comprobante.numero_placa;
            this.form.id_transportista = comprobante.id_persona;
            this.nombre_transportista = comprobante.nombre_trans_remit;
            this.id_comprobante = comprobante.id_comprobante;
            this.numero_identificacion = comprobante.identificacion_trans_remit;
            this.form.direccion_partida = comprobante.direccion_partida;
            this.form.fecha_inicio_transporte = moment(new Date(comprobante.fecha_ini_trans)).format('YYYY-MM-DD');
            this.form.fecha_fin_transporte = moment(new Date(comprobante.fecha_fin_trans)).format('YYYY-MM-DD');
            this.form.detalles = [];
            this.form.informacionAdicional = [];
            for (let i = 0; i < comprobante.detalles_gr.length; i++)
            {
                if (comprobante.detalles_gr[i].destinatario !== null) {
                    let detalle = {
                        id_destinatario : comprobante.detalles_gr[i].destinatario.id,
                        identificacion_destinatario : comprobante.detalles_gr[i].identificacion_destinatario,
                        nombre_destinatario : comprobante.detalles_gr[i].razon_social_destinatario,
                        direccion_destinatario : comprobante.detalles_gr[i].direccion_destinatario,
                        motivo_traslado : comprobante.detalles_gr[i].motivo_traslado,
                        documento_aduanero : comprobante.detalles_gr[i].doc_aduanero_unico,
                        cod_establecimiento : comprobante.detalles_gr[i].cod_establecimiento_destino,
                        ruta : comprobante.detalles_gr[i].ruta,
                        cod_doc_sustento : comprobante.detalles_gr[i].cod_doc_sustento,
                        numero_documento : comprobante.detalles_gr[i].num_doc_sustento,
                        numero_aut_documento : comprobante.detalles_gr[i].num_aut_doc_sustento,
                        fecha_emision_doc : comprobante.detalles_gr[i].fecha_emi_doc_sustento !== null?moment(new Date(comprobante.detalles_gr[i].fecha_emi_doc_sustento)).format('YYYY-MM-DD'):'',
                        id_comprobante : comprobante.detalles_gr[i].comprobante !== null?comprobante.detalles_gr[i].comprobante.id_comprobante:'',
                        detalles : [],
                        email : '',
                        telefono : ''
                    };
                    for (let j = 0; j < comprobante.detalles_gr[i].items.length; j++)
                        detalle.detalles.push({
                            codigo : comprobante.detalles_gr[i].items[j].codigo_interno,
                            descripcion : comprobante.detalles_gr[i].items[j].descripcion,
                            cantidad : comprobante.detalles_gr[i].items[j].cantidad,
                            serie : comprobante.detalles_gr[i].items[j].codigo_adicional,
                            cantidad_gr : comprobante.detalles_gr[i].items[j].cantidad
                        });
                    this.form.detalles.push(detalle);
                }
            }
            this.anulado = comprobante.anulado;
            for (let i = 0; i < comprobante.detalles_adicionales.length; i++)
                this.form.informacionAdicional.push({
                    nombre_campo : comprobante.detalles_adicionales[i].nombre,
                    valor_campo : comprobante.detalles_adicionales[i].valor
                });
           for (let i = 0; i < this.puntosEmision.length; i++)
                if (this.puntosEmision[i].localidad.numero_localidad === comprobante.codigo_establecimiento && 
                    this.puntosEmision[i].numero_secuencia === comprobante.codigo_emisor)
                    this.selectedPuntoEmision = this.puntosEmision[i];
            if (comprobante.fecha_autorizacion !== null)
            {
                if (this.selectedPuntoEmision !== null && this.selectedPuntoEmision.tipo === 'M')
                    this.form.fecha_autorizacion = moment(new Date(comprobante.fecha_autorizacion)).format('YYYY-MM-DD')
                else 
                    this.form.fecha_autorizacion = moment(new Date(comprobante.fecha_autorizacion)).format('YYYY-MM-DD HH:mm:ss')
            }
            else 
                this.form.fecha_autorizacion = '';
            this.form.numero_autorizacion = comprobante.numero_autorizacion;
            this.$modal.hide('listaGuiasRemision');
        },
        quitarPersona : function () {
            this.nombre_transportista = '';
            this.form.id_transportista = '';
        },
        cargarDatosComprobante : function () {
            let that = this;
            axios.get(this.url + '/comprobantes/' + this.codigoGuiaRemision + '/datos-guia-remision').then(function (response) {
                that.puntosEmision = response.data.puntosEmision;
                if (that.puntosEmision.length > 0)
                    that.selectedPuntoEmision = that.puntosEmision[0];
                if (that.comprobante === null)
                    that.cargarFactura();
                else 
                    that.selectedComprobante(that.comprobante);
            });
        },
        cargarFactura : function () {
            if (this.factura !== null) {
                let detalle = {
                    id_destinatario : this.factura.id_persona,
                    identificacion_destinatario : this.factura.numero_identificacion,
                    nombre_destinatario : this.factura.nombre_cliente,
                    direccion_destinatario : this.factura.direccion_cliente,
                    motivo_traslado : '',
                    documento_aduanero : '',
                    cod_establecimiento : this.factura.codigo_establecimiento,
                    ruta : '',
                    cod_doc_sustento : this.factura.id_tipo_comprobante,
                    numero_documento : this.factura.numero_documento,
                    numero_aut_documento : this.factura.numero_autorizacion,
                    fecha_emision_doc : moment(new Date(this.factura.fecha_emision)).format('YYYY-MM-DD'),
                    id_comprobante : this.factura.id_comprobante,
                    detalles : [],
                    email : this.factura.correo_cliente,
                    telefono : this.factura.cliente.telefono
                };
                for (let i = 0; i < this.factura.items.length; i++) {
                    if (this.factura.items[i].item !== null && this.factura.items[i].item.tipo_item === 'P') {
                        detalle.detalles.push({
                            codigo : this.factura.items[i].id_item,
                            descripcion : this.factura.items[i].descripcion === null?this.factura.items[i].descripcion_item:this.factura.items[i].descripcion,
                            cantidad : this.factura.items[i].cantidad_disponible,
                            serie : '',
                            cantidad_gr : 0
                        });
                    }
                }
                if (detalle.detalles.length > 0)
                    this.form.detalles.push(detalle);
                else 
                    swal('No hay items disponibles para realizar la guia.', 'Aviso', 'warning');
            }
        },
        obtenerInformacionAdicional : function (nombre) {
            for (let i = 0; i < this.form.informacionAdicional.length; i++) 
                if (this.form.informacionAdicional[i].nombre_campo === nombre)
                    return this.form.informacionAdicional[i];
            return null;
        },
        limpiarErrores : function () {
            this.errores = {};
        },
        guardarComprobante : function () {
            this.limpiarErrores();
            for (let i = 0; i < this.form.detalles.length; i++) {
                if (this.form.detalles[i].motivo_traslado == null || this.form.detalles[i].motivo_traslado == '') {
                    swal('Las guías deben tener un motivo de traslado. Por favor, edite la guía a la que no se haya agregado motivo de traslado e intente nuevamente.', 'Aviso', 'warning');
                    return;
                }
            }
            let that = this;
            let urlRequest = this.url + '/comprobantes/guia-remision';
            if (that.estado !== 'N')
            {
                urlRequest += '/' + that.id_comprobante;
                that.form._method = 'PUT';
            }
            else 
                that.form._method = undefined;
            axios.post(urlRequest, that.form).then(function (response) {
                that.id_comprobante = response.data.id_comprobante;
                that.clave_acceso = response.data.clave_acceso;
                that.numero_comprobante = response.data.numero_documento;
                that.estado = response.data.id_estado_comprobante;
                for (let i = 0; i < that.form.detalles.length; i++)
                        for (let j = 0; j < that.form.detalles[i].detalles.length; j++) {
                            that.form.detalles[i].detalles[j].cantidad_gr = that.form.detalles[i].detalles[j].cantidad;
                        }
                swal('El comprobante ha sido almacenado.', 'Realizado', 'success');
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        let status = response.status;
                        if (status === 422)
                        {
                            that.errores = response.data.errors;
                            swal('Hay errores en el comprobante.', 'Error', 'warning');
                        }
                        else if (status === 403) 
                            swal('Verifique la fecha de caducidad del comprobante o la existencia de secuencias.', 'Error', 'warning');
                        else 
                            swal('Hubo un error al almacenar el comprobante, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        anularComprobante : function () {
            let that = this;
            swal({
                title: '¿Desea anular este comprobante?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Anular comprobante',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    axios.post(that.url + '/comprobantes/' + that.id_comprobante + '/anular', {
                        _method : 'DELETE'
                    }).then(function (response) {
                        that.anulado = 'S';
                        swal('El comprobante ha sido anulado.', 'Anulado', 'success');
                    });
                }
            })
        },
        savedPersona : function (persona) {
            this.selectedPersona(persona);
            this.$modal.hide('persona');
        },
        crearNuevaPersona : function () {
            this.$modal.show('persona');
        },
        selectedPersona : function (persona) {
            this.form.id_transportista = persona.id;
            this.numero_identificacion = persona.identificacion;
            this.nombre_transportista = persona.nombre;
            this.$modal.hide('listaTransportistas');
        },
        consultarCliente : function() {
            if (this.numero_identificacion !== '') {
                let that = this;
                axios.get(this.url + '/personas/' + this.numero_identificacion, {
                    params : {
                        tipoFiltro : 'T'
                    }
                }).then(function (response) {
                    that.selectedPersona(response.data);
                }).catch(function (error) {
                    if (error !== undefined && error !== null) {
                        let response = error.response;
                        if (response !== undefined && response !== null) {
                            let status = response.status;
                            if (status === 404) {
                                swal({
                                    title: '¿Desear crear una nueva persona?',
                                    text: "Esta acción requiere de confirmación.",
                                    type: 'question',
                                    showCancelButton: true,
                                    confirmButtonText: 'Nueva persona',
                                    cancelButtonText : 'No'
                                }).then((result) => {
                                    if (result.value)
                                        that.crearNuevaPersona();                 
                                });
                            }
                            else 
                                swal('Hubo un error al momento de consultar el número. Intente nuevamente.', 'Error', 'error');
                        }
                    }
                });
            }
            else 
                swal('Debe ingresar un número de identificación.', 'Aviso', 'warning');
        },
        imprimirComprobante : function () {
            if (this.selectedPuntoEmision.punto_venta === 'S')
                this.$modal.show('imprimir');
            else 
                window.open(this.url + '/comprobantes/' + this.id_comprobante + '/ride', '_blank');
        },
        enviarCorreo : function () {

        },
        abrirLogs : function () {
            window.open(this.url + '/comprobantes/' + this.id_comprobante + '/logs', '_blank');
        }
    },
    computed : {
        tieneTransportista : function () {
            return this.form.id_transportista !== '';
        },
        editable : function () {
            return (this.estado === 'N' || (this.anulado !== 'S' && this.estado  !== 'PPR' && this.estado !== 'AUT')) && this.pendiente_envio !== 'S';
        },
        esElectronico : function () {
            return this.selectedPuntoEmision !== null?this.selectedPuntoEmision.tipo === 'E':true;
        },
        enColaAutorizacion : function () {
            return this.pendiente_envio === 'S';
        }
    }, 
    mounted : function () {
        this.cargarDatosComprobante();
    },
    watch : {
        selectedPuntoEmision : function (value) {
            if (value !== undefined && value !== null)
            {
                this.form.id_punto_emision = value.id;
                if (value.tipo === 'M' && this.estado === 'N') {
                    this.form.numero_autorizacion = value.numero_autorizacion;
                    this.form.fecha_autorizacion = moment(new Date(value.fecha_autorizacion)).format('YYYY-MM-DD');
                    this.clave_acceso = '';
                }
                else if (this.estado === 'N')
                {
                    this.form.numero_autorizacion = '';
                    this.form.fecha_autorizacion = '';
                }
            }
            else 
                this.form.id_punto_emision = '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/GuiaRemision.vue